import React from 'react';
import DepartmentSettingsPage from './DepartmentSettingsPage';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import mapsActions from '../../../../../actions/maps.actions';
import { bindActionCreators } from 'redux';
import { generalActions } from '../../../../../actions/general.action';
import helper from '../../../../../utils/helper';
import lookupActions from '../../../../../actions/lookup.actions';
import { updateDepartmentLogo } from '../../../../../api/department';
import { store } from '../../../../../utils/store';
import { actionConstants } from '../../../../../actions/actionConstants';

const locale = [
  { label: 'English', value: 'en_US' },
  { label: 'Espanol', value: 'es' },
];

class DepartmentSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      department: {},
      getDepartmentError: {},
      departmentSettings: [],
      maps: [],
      timezones: [],
      loading: false,
      isSubmitting: false,
      errors: '',
      isLogoChanged: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.department !== prevState.department) {
      state.department = nextProps.configure.department;
    }
    if (
      nextProps.configure.departmentSettings !== prevState.departmentSettings
    ) {
      state.departmentSettings = nextProps.configure.departmentSettings;
    }
    if (nextProps.maps.maps !== prevState.maps) {
      state.maps = nextProps.maps.maps;
    }
    if (nextProps.lookup.timezones !== prevState.timezones) {
      state.timezones = nextProps.lookup.timezones;
    }
    if (
      nextProps.configure.getDepartmentError !== prevState.getDepartmentError
    ) {
      state.getDepartmentError = nextProps.configure.getDepartmentError;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.maps.errors,
    ]);
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    const { id } = this.props.match.params;
    this.props.generalActions.clearError();
    await this.props.configureActions.getSpecificDepartment(id);
    await this.props.mapsActions.getMapsByDept(id);
    await this.props.configureActions.getDeptSettingsByLocale(id);
    await this.props.lookupActions.getTimezones();
  }
  onDepartmentSettings = (values, logo) => {
    const { id } = this.props.match.params;
    this.setState(
      { isSubmitting: true },
      async () =>
        await this.props.configureActions
          .editDepartment(id, {
            name: values.name,
            description: values.description,
          })
          .then(
            async () =>
              await this.props.configureActions
                .departmentSettings(id, values)
                .then(() => {
                  const profile = JSON.parse(
                    localStorage.getItem('userProfile'),
                  );
                  if (parseInt(id) === profile.departmentId) {
                    this.props.configureActions.getDeptSettingsByLocale(
                      id,
                      'en_US',
                      true,
                    );
                  }
                })
                .then(async () => {
                  if (this.state.isLogoChanged) {
                    await updateDepartmentLogo(id, { logoBase64: logo })
                      .then(() => {
                        store.dispatch({
                          type: actionConstants.LOGO_HAS_UPDATED,
                          data: true,
                        });
                      })
                      .catch(() => this.setState({ isSubmitting: false }));
                  }
                })
                .then(() => this.props.history.push('/configure/departments'))
                .catch(() => this.setState({ isSubmitting: false })),
          )
          .catch(() => this.setState({ isSubmitting: false })),
    );
  };
  render() {
    const { departmentSettings, loading, department } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    const form = {};
    if (Object.keys(department).length) {
      form.name = department.name;
      form.description = department.description;
    }
    if (departmentSettings.length) {
      let value = '';
      departmentSettings.map((dept) => {
        if (dept.value === 'true' || dept.value === 'True') {
          value = true;
        } else if (dept.value === 'false' || dept.value === 'False') {
          value = false;
        } else {
          value = dept.value;
        }
        if (dept.value === null) {
          value = '';
        }
        // if (dept.parameter === 'Locale') {
        //   form.LocaleName = locale.filter(
        //     (l) => l.value === dept.value,
        //   )[0].label;
        // }
        form[dept.parameter] = value;
      });
    }
    return (
      <DepartmentSettingsPage
        {...this.state}
        form={form}
        onDepartmentSettings={this.onDepartmentSettings}
        onDepartmentLogoChanged={() => this.setState({ isLogoChanged: true })}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    maps: state.maps,
    lookup: state.lookup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    mapsActions: bindActionCreators(Object.assign({}, mapsActions), dispatch),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentSettings);
